import Vue from 'vue'
import VueRouter from 'vue-router'
// import store from '../store'

// import Home from '../views/Home.vue'
// import QuranDetail from '../views/QuranDetail.vue'
import Login from '../views/Login.vue'
import Bookmark from '../views/Bookmark.vue'
import Khazanah from '../views/Khazanah/Index.vue'
import KhazanahDetail from '../views/Khazanah/Detail.vue'
import HomeQuran from '../views/HomeQuran.vue'
import HomeNew from '../views/HomeNew.vue'
import QuranDetail from '../views/QuranDetailNew.vue'
import HomeKataAyat from '../views/HomeKataAyat.vue'
import LearnQuran from '../views/LearnQuran.vue'
import VueCookie from 'vue-cookie'

Vue.use(VueRouter)

const routes = [
    // {
    //     path: '/',
    //     name: 'home',
    //     component: Home,
    //     meta: { 
    //         title: "Quran",
    //         isBack: false,
    //         requiresAuth: true
    //     }
    // },
    {
        path: '/',
        name: 'home',
        component: HomeQuran,
        meta: { 
            title: "Quran",
            isBack: false,
            requiresAuth: true
        }
    },
    {
        path: '/quran',
        name: 'quran.index',
        component: HomeNew,
        meta: { 
            title: "Quran",
            isBack: true
        }
    },
    {
        path: '/quran/surah/:id',
        name: 'quran.detail',
        component: QuranDetail,
        props: true,
        meta: { 
            title: "Quran Detail" ,
            isBack: true,
            requiresAuth: true
        }
    },
    {
        path: '/khazanah',
        name: 'khazanah.index',
        component: Khazanah,
        meta: { 
            title: "Khazanah",
            isBack: false,
            requiresAuth: true
        }
    },
    {
        path: '/khazanah/detail/:id',
        name: 'khazanah.detail',
        component: KhazanahDetail,
        props: true,
        meta: { 
            title: "Khazanah Detail" ,
            isBack: true,
            requiresAuth: true
        }
    },
    {
        path: '/learn-quran',
        name: 'learnQuran',
        component: LearnQuran,
        meta: { 
            title: "Belajar Quran",
            isBack: true,
            requiresAuth: true
        }
    },
    {
        path: '/learn-quran/kata',
        name: 'learnQuranWord',
        component: HomeKataAyat,
        meta: { 
            title: "Quran",
            isBack: true
        }
    },
    {
        path: '/bookmark',
        name: 'bookmark',
        component: Bookmark,
        meta: { 
            title: "Bookmark",
            isBack: false,
            requiresAuth: true
        }
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: { 
            title: "Login",
            isBack: false,
            requiresAuth: false
        }
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    let auth = VueCookie.get('token')
    if (to.matched.some((record) => record.meta.requiresAuth)) {
       if (!auth) {
          next({ name: "login" })
       } else {
          next()
       }
    } else {
       if(auth && to.name == "login"){
          next({name: "home"})
       }
       next()
    }
 })

export default router